<template>
  <div class="slide-navigation-item m-2 p-0 btn btn-secondary" tabindex="0" :class="{'disabled': disabled }" @click.prevent="$emit('goToSlide', slide.id)">
    <div class="p-2 text-light " :class="{'bg-theme': active}">
      <h6 class="text-truncate mb-0">{{title}}</h6>
    </div>
    <PreviewSlide :slide="slide"></PreviewSlide>
    <div class="p-2 text-light d-flex justify-content-between align-items-center" :class="{'bg-theme': active}">
      <span class="font-weight-bold">{{slide.position}}</span>
      <div>
        <i v-if="isBallot && slide.result" class="fas fa-poll me-1" v-tooltip="$t('js.tooltips.result_ready')"></i>
        <i v-if="typeIcon" :class="typeIcon" v-tooltip="$t('js.tooltips.ballot')"></i>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters, mapState} from "vuex"
import PreviewSlide from "./PreviewSlide.vue"

export default {
  name: 'SlideNavigation',
  components: {PreviewSlide},
  props: {
    active: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    slide: {
      type: Object,
      required: false,
      default: ()=>{
        return {type: 'none'}
      }
    },
  },
  computed: {
    ...mapState(['election', 'electionUrl']),
    ...mapGetters(['firstAvailableLocale']),
    title(){
      let title = this.slide.internalName ? this.slide.internalName : this.slide.title[this.firstAvailableLocale];
      if(title === "" || title === undefined){
        title = this.$t('js.slide.one')+ " #" + this.slide.position
      }
      return title;
    },
    description(){
      return this.slide.description[this.firstAvailableLocale];
    },
    isBallot(){
      return this.slide.type === 'Slides::BallotSlide'
    },
    typeIcon(){
      if(this.isBallot){
        return 'fas fa-vote-yea'
      }
    },
    backgroundStyle(){
      if (this.slide.background) {
        return {
          backgroundImage: `url('${this.slide.background}')`,
          backgroundAttachment: 'local',
          backgroundSize: 'cover'
        };
      } else {
        return {backgroundColor: '#fff'}
      }
    }
  },
  mounted(){
    $('[data-bs-toggle="tooltip"]').tooltip();
  }
}
</script>